@if (pageReady) {
  <main class="gs-page">
    <div class="change-address-container">
      <app-page-header [headerData]="headerData"></app-page-header>
      <div class="notification-container">
        <app-notification [pageName]="pageName"></app-notification>
      </div>
      <div class="gs-content-container">
        <h2 class="change-address-label">{{ pageLabels.changeAddressTitleText }}</h2>
        <app-mailing-address
          [mailingAddressData]="mailingAddressFormData"
          [unverifiedAddress]="unverifiedAddress"
          (dataEmitter)="unverifiedAddressData($event)"
        ></app-mailing-address>
      </div>
      <div class="cta-container">
        <a
          [routerLink]="pageLabels.changeAddressManageAccountLink.value.data.url"
          class="change-link"
          [attr.aria-label]="pageLabels.changeAddressKeepAddressLinkAriaLabel"
          >{{ pageLabels.changeAddressKeepAddressLinkText }}</a
        >
        <button
          role="link"
          mat-flat-button
          color="primary"
          class="gs-form-button-primary"
          (click)="updateMailingAddress()"
        >
          {{ pageLabels.changeAddressButtonText }}
        </button>
      </div>
    </div>
  </main>
}
